import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getAllChargersPaginated: UseCase<ChargerRepository, 'getAllChargersPaginated'> = repository => {
  return async (groupUid, params) => {
    const chargers = await repository.getAllChargersPaginated(groupUid, params)

    return chargers
  }
}
